export const LIKE = 'LIKE';
export const EQ = '=';
export const NE = '!=';
export const GT = '>';
export const GE = '>=';
export const LT = '<';
export const LE = '<=';



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2-filter/src/comparison.js